<template>
  <div class="editorial_course_wrap" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
    <div style="width: 100%;height: 100%" v-if="!isSetMenu">
      <div class="editorial_course_title">
        <p class="goback" @click="goback">
          <img src="../../../../static/images/course/icon-3.png" alt="">
          <span>返回</span>
        </p>
        <h2>{{courseName}}</h2>
        <div class="edit_and_preview">
          <el-button v-if="!isEditCourse" @click="setMenu(true)">设置</el-button>
          <el-button v-if="!isEditCourse" @click="isEditCourse = true">编辑基本信息</el-button>
          <el-button v-if="isEditCourse" @click="isEditCourse = false">取消</el-button>
          <el-button v-if="isEditCourse" @click="saveCourseInfo">保存</el-button>
          <el-button v-if="!isEditCourse" @click="previewCourse">预览</el-button>
        </div>
      </div>
      <div class="course_info" v-if="!isEditCourse">
        <div class="course_tree">
          <div class="course_chapters">
            <img src="../../../../static/images/course/icon-1.png" alt="" class="icon">
            <h3>目录</h3>
            <img src="../../../../static/images/course/icon-2.png" alt="" @click="addCatalog" class="add_course_btn">
          </div>
          <div class="course_CTreeCtrl" :style="'height:'+(windowHeight-230)+'px'">
            <el-tree
              ref="tree"
              :data="treeData"
              :props="defaultProps"
              empty-text="暂无目录"
              node-key="id"
              :default-expanded-keys="defaultExpansion"
              :default-expand-all="false"
              :highlight-current="true"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              @node-drag-start="handleDragStart"
              @node-drag-enter="handleDragEnter"
              @node-drag-leave="handleDragLeave"
              @node-drag-over="handleDragOver"
              @node-drag-end="handleDragEnd"
              @node-drop="handleDrop"
              :draggable="isdraggable"
            >
              <p class="custom-tree-node"
                 slot-scope="{ node, data }" :title="node.label"
                 style="display: flex; align-items: center; justify-content: space-between; padding-right: 8px;height:100%">
                <el-input
                  v-if="data.status&&data.status==1"
                  class="nodeInput" maxlength="30"
                  v-model.trim="data.catalogName" size="small" :ref="'catalog'+data.id"
                  @blur="editCatalogSave(data, node)"
                  @keyup.enter.native="enterInput($event)"
                  @click.stop.native
                ></el-input>
                <span v-else style="height: 32px;line-height: 32px;">{{ node.label }}</span>
                <span v-if="data.status!=1" class="course_catalog_operation">
              <i class="el-icon-plus" title="添加" v-if="productFlag!=7" @click.stop="() => appendCatalog(data, node)"></i>
              <i class="el-icon-edit-outline" title="修改" @click.stop="editCatalog(node, data)"></i>
              <i class="el-icon-delete" title="删除" @click.stop="() => removeCatalogFn(node, data)"></i>
            </span>
              </p>
            </el-tree>
          </div>
        </div>
        <div class="editorial_course_content">
          <div class="cc_title">
            <h2 v-if="isTreeNodeClick">
              <img src="../../../../static/images/course/icon-4.png" alt="">
              <p style="height: 24px;line-height: 24px;" :title="catalogInfo.name">{{catalogInfo.name}}</p>
            </h2>
            <div class="operation_btn" v-if="isTreeNodeClick">
              <div class="operation_btn_left" v-if="isBlock&&relatedMaterialData.length>0">
                <el-checkbox :indeterminate="isIndeterminateSource" v-model="isSelectAll" @change="checked=>handleCheckAllChange('all',checked)">全选</el-checkbox>
                <el-checkbox :indeterminate="isIndeterminateTask" v-model="isSelectAllTask" :disabled="taskIsdisabled" @change="checked=>handleCheckAllChange('task',checked)">全部设为任务</el-checkbox>
                <el-checkbox :indeterminate="isIndeterminateDown" v-model="isSelectAllDown" @change="checked=>handleCheckAllChange('down',checked)">全部允许下载</el-checkbox>
              </div>
              <div v-else></div>
              <div class="operation_btn_right">
                <el-button @click="isAddMaterial = true">添加素材</el-button>
                <el-button @click="uploadMaterialDrawer">上传素材</el-button>
                <el-button @click="addQuestionShow = true">添加实操题</el-button>
                <el-button @click="createQuestionBtn">创建实操题</el-button>
                <el-button @click="addTestpaperShow(catalogInfo)" v-if="productFlag == 1">添加测验</el-button>
                <el-button @click="batchDelete">删除</el-button>
                <el-button @click="isBlock = !isBlock" :class="isBlock?'block':'list'"></el-button>
              </div>
            </div>
          </div>
          <div class="cc_content" :style="'height:'+(windowHeight-270)+'px'" v-if="relatedMaterialData.length>0">
            <div class="source_table_title" v-if="!isBlock">
              <p><el-checkbox :indeterminate="isIndeterminateSource" v-model="isSelectAll" @change="checked=>handleCheckAllChange('all',checked)"></el-checkbox></p>
              <p>序号</p>
              <p>资源标题</p>
              <p>类型</p>
              <p><el-checkbox :indeterminate="isIndeterminateTask" v-model="isSelectAllTask" :disabled="taskIsdisabled" @change="checked=>handleCheckAllChange('task',checked)">设为任务</el-checkbox></p>
              <p><el-checkbox :indeterminate="isIndeterminateDown" v-model="isSelectAllDown" @change="checked=>handleCheckAllChange('down',checked)">允许下载</el-checkbox></p>
              <p>操作</p>
            </div>
            <draggable v-model="relatedMaterialData" @update="sourceSort" tag="ul" class="block" v-if="isBlock">
              <li v-for="(item,key) in relatedMaterialData" :data-key="item.id" :key="key">
                <div :class="'img_box '+imgBg(item.resourceType,item.type)">
                  <el-checkbox-group v-model="seleceSource" @change="checked=>handleCheckedTopicChange('all',checked)" class="select_box">
                    <el-checkbox :label="item.courseResourceId" :key="item.courseResourceId"></el-checkbox>
                  </el-checkbox-group>
                  <img src="../../../../static/images/course/delete.png" alt="" class="delete_source" @click="deleteSource1(item)">
                  <img src="../../../../static/images/course/blockIcon/pic.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==1" @click="previewDocument(item)">
                  <img src="../../../../static/images/course/blockIcon/file.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==2" @click="previewDocument(item)">
                  <img src="../../../../static/images/course/blockIcon/audio.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==3" @click="previewDocument(item)">
                  <img src="../../../../static/images/course/blockIcon/video.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==4" @click="previewDocument(item)">
                  <img src="../../../../static/images/course/blockIcon/zip.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==5" @click="previewDocument(item)">
                  <img src="../../../../static/images/course/blockIcon/question.png" alt="" class="source_icon" v-if="item.resourceType==3">
                  <img src="../../../../static/images/course/blockIcon/test.png" alt="" class="source_icon" v-if="item.resourceType==5">
                </div>
                <div class="title_box">
                  <p :title="item.name" v-if="item.resourceType==1">{{item.name}}</p>
                  <p :title="item.name" v-if="item.resourceType==3">{{item.name?item.name:'实操题'+item.id}}</p>
                  <p :title="item.name" v-if="item.resourceType==5">{{item.name}}</p>
                  <i v-if="item.resourceType==3 || item.resourceType==5" class="el-icon-edit-outline" title="编辑" @click="handleGoResource(item)"></i>
                </div>
                <div class="isDownload">
                  <el-checkbox-group v-if="(item.resourceType==3&&productFlag==7)||productFlag!=7" v-model="seleceTask" @change="checked=>handleCheckedTopicChange('task',checked,item)">
                    <el-checkbox :label="item.courseResourceId" :key="item.courseResourceId">设为任务</el-checkbox>
                  </el-checkbox-group>
                  <el-checkbox-group v-model="seleceDown" @change="checked=>handleCheckedTopicChange('down',checked,item)" v-if="item.resourceType==1">
                    <el-checkbox :label="item.courseResourceId" :key="item.courseResourceId" v-if="item.resourceType==1">允许下载</el-checkbox>
                  </el-checkbox-group>
                </div>
              </li>
            </draggable>
            <draggable v-model="relatedMaterialData" @update="sourceSort" tag="ul" class="list" v-else>
              <li v-for="(item,key) in relatedMaterialData" :data-key="item.id" :key="key">
                <div class="select_box">
                  <el-checkbox-group v-model="seleceSource" @change="checked=>handleCheckedTopicChange('all',checked)">
                    <el-checkbox :label="item.courseResourceId" :key="item.courseResourceId"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="index_box">{{key+1}}</div>
                <div class="title_box">
                  <p :title="item.name" v-if="item.resourceType==1">{{item.name}}</p>
                  <p :title="item.name" v-if="item.resourceType==3">{{item.name?item.name:'实操题'+item.id}}</p>
                  <p :title="item.name" v-if="item.resourceType==5">{{item.name}}</p>
                </div>
                <div class="type_box">
                  <img src="../../../../static/images/course/listIcon/pic.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==1"><span v-if="item.resourceType==1 && item.type==1">图片</span>
                  <img src="../../../../static/images/course/listIcon/file.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==2"><span v-if="item.resourceType==1 && item.type==2">文件</span>
                  <img src="../../../../static/images/course/listIcon/audio.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==3"><span v-if="item.resourceType==1 && item.type==3">音频</span>
                  <img src="../../../../static/images/course/listIcon/video.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==4"><span v-if="item.resourceType==1 && item.type==4">视频</span>
                  <img src="../../../../static/images/course/listIcon/zip.png" alt="" class="source_icon" v-if="item.resourceType==1 && item.type==5"><span v-if="item.resourceType==1 && item.type==5">zip</span>
                  <img src="../../../../static/images/course/listIcon/question.png" alt="" class="source_icon" v-if="item.resourceType==3"><span v-if="item.resourceType==3">试题</span>
                  <img src="../../../../static/images/course/listIcon/test.png" alt="" class="source_icon" v-if="item.resourceType==5"><span v-if="item.resourceType==5">试卷</span>
                </div>
                <div class="task_box">
                  <el-checkbox-group v-if="(item.resourceType==3&&productFlag==7)||productFlag!=7" v-model="seleceTask" @change="checked=>handleCheckedTopicChange('task',checked,item)">
                    <el-checkbox :label="item.courseResourceId" :key="item.courseResourceId"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="down_box">
                  <el-checkbox-group v-model="seleceDown" @change="checked=>handleCheckedTopicChange('down',checked,item)" v-if="item.resourceType==1">
                    <el-checkbox :label="item.courseResourceId" :key="item.courseResourceId" v-if="item.resourceType==1"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="operation_box">
                  <span title="预览" class="preview_source" @click="previewDocument(item)" v-if="item.resourceType==1"></span>
                  <span title="编辑" class="edit_source" v-if="item.resourceType==3 || item.resourceType==5" @click="handleGoResource(item)"></span>
                  <span title="删除" class="delete_source" @click="deleteSource1(item)"></span>
                  <span title="下移" class="down_source" @click="downMove(key,item)" v-if="key!=relatedMaterialData.length-1"></span>
                  <span title="上移" class="up_source" @click="upMove(key,item)" v-if="key!=0"></span>
                </div>
              </li>
            </draggable>
          </div>
          <div v-else class="no_content">
            <img src="../../../../static/images/wujieguo.png" alt="">
            <p>暂无内容</p>
          </div>
        </div>
      </div>
      <div class="edit_info" v-else>
        <edit-course
          ref="editInfo"
          :editCourseInfoForm="editCourseInfoForm"
          :imageUrl="imgUrl" :courseId="Number(courseId)"></edit-course>
      </div>
      <el-drawer
        :visible.sync="isAddMaterial"
        :direction="direction"
        size="80%"
        destroy-on-close
        :with-header="false"
      >
        <addMaterial @closeAddMaterial="closeAddMaterial" :subjectId="editCourseInfoForm.subject"></addMaterial>
      </el-drawer>
      <el-drawer
        :visible.sync="isUploadMaterial"
        :direction="direction"
        size="80%"
        destroy-on-close
        :with-header="false"
      >
        <uploadMaterial ref="uploadMaterial" :subjectId="editCourseInfoForm.subject" :isUploadMaterial="isUploadMaterial" @uploadMaterial="uploadMaterial" @uploadMaterialClick="uploadMaterialClick"></uploadMaterial>
      </el-drawer>
      <el-drawer :visible.sync="addQuestionShow" :direction="direction" size="80%" :with-header="false" :close-on-press-escape="false" :before-close="closeQuestion">
        <addQuestion ref="addQuestion" @addQuestionSave="addQuestionSave" :addQuestionShow="addQuestionShow" @cancelQuestion="closeQuestion" :subject="editCourseInfoForm.subject"></addQuestion>
      </el-drawer>
      <el-drawer :visible.sync="createQuestionShow" :direction="direction" size="80%" :with-header="false" :close-on-press-escape="false" :before-close="closeCreateQuestion">
        <createQuestion
         ref="addTestpaper"
         :createQuestionShow="createQuestionShow"
         @closeCreateQuestion="closeCreateQuestion"
         @saveQuestion="saveQuestion"></createQuestion>
      </el-drawer>
      <el-drawer :visible.sync="dialogResourceVisible" :direction="direction" size="80%" :with-header="false" :close-on-press-escape="false" :before-close="viewResourceCancel">
        <view-resource
          :resourceVisible="resourceVisible"
          :resourceUrl="resourceUrl"
          :posterSrc="posterSrc"
          @onclickCancel="viewResourceCancel"
          @oncilckConfirm="viewResourceConfirm"
          :resourceInfo="resourceInfo">
        </view-resource>
      </el-drawer>
    </div>
    <setCatalog v-else></setCatalog>
  </div>
</template>

<script>
  import * as api from '../../../api/courseApi'
  import axios from 'axios'
  import qs from 'qs'
  import draggable from 'vuedraggable'
  import viewResource from './components/viewResourceDialog'
  import addMaterial from  './addMaterial'
  import uploadMaterial from  './uploadMaterial'
  import addQuestion from './components/addQuestion'
  import addTestpaper from './addTestpaper'
  import editCourse from './editCourseInfo'
  import createQuestion from './components/createQuestion'
  import setCatalog from './setCatalog'
  export default {
    components: {
      draggable,
      viewResource,
      addMaterial,
      uploadMaterial,
      addQuestion,
      addTestpaper,
      editCourse,
      createQuestion,
      setCatalog
    },
    inject: ['reload'],
    data() {
      return {
        //  other
        loading: true,
        windowHeight: window.innerHeight,
        courseId: this.$route.query.id,//课程ID
        courseProfessional: '',
        isTreeNodeClick: false,//是否选中目录
        treeDataLevel:'',//目录层级
        isBlock: false,
        addQuestionShow: false,//添加实操题
        treeData: [],//目录树数据
        defaultProps: {//目录配置
          children: 'children',
          label: 'catalogName'
        },
        defaultExpansion:[],//默认展开的节点
        selectTreeData: null,//选中的目录
        isEditCourse: false,//是否编辑课程
        editCourseInfoForm:{//编辑课程信息
          courseName: '',
          courseIntroduction: '',
          subject: '',
          classHour: '',
          coursePic: '',
          courseDetails: '',
          post: []
        },
        catalogFlag: false,
        imgUrl:'',//课程封面
        courseName: '无课程',
        relatedMaterialData:[],//目录关联资源
        checkListAll: [],
        checkList: [],
        taskList: [],
        isIndeterminateSource: false,
        isIndeterminateTask: false,
        isIndeterminateDown: false,
        isSelectAll: false,//全选
        isSelectAllTask: false,//全选设为任务
        isSelectAllDown: false,//全选允许下载
        seleceSource: [],//选中的资源
        seleceTask: [],//选中任务
        seleceDown: [],//选中下载
        isAddMaterial:false,//添加
        isUploadMaterial:false,//上传
        direction: 'rtl',
        catalogInfo: {
          name: '',
          id: ''
        },
        isdraggable: true,//目录是否能移动
        resourceInfo:{//查看资源的关联信息
          name: '',
          classification: '',
          uploader: '',
          uploadTime: ''
        },
        productFlag: sessionStorage.getItem('productFlag'),
        //==========查看素材==================
        dialogResourceVisible: false,
        resourceVisible:0,
        resourceUrl:'',
        posterSrc:'',
        //==========创建实操题================
        createQuestionShow: false,
        isCreate: true,//防止连续创建试题
        //==========设置目录================
        isSetMenu: false,
        taskIsdisabled:false,
      }
    },
    created() {
      
      this.getCourseInfo(this.courseId)
      this.getCourseCatalog(this.courseId)
    },
    methods: {
      goback(){//返回
        if (this.type == 1 ){
          this.$router.replace({ path: "/resource/courseadmin"});
        } else if (this.type == 2 ){
          this.$router.replace({ path: "/trainingCenter/trainingCourses"});
        } else {
          this.$router.go(-1);
        }
      },
      getCourseInfo(courseid){//获取课程信息
        let that = this
        api.getCourseInfo(courseid).then((rs)=>{
          if(rs.code==0){
            that.courseName = rs.data.courseName
            that.courseProfessional = rs.data.courseProfessional

            let imgsrc = '';
            if(rs.data.courseLogo != ''){
              let str = rs.data.courseLogo;
              imgsrc = str
            }else{
              imgsrc = ''
            }
            that.imgUrl = imgsrc
            let arr = []
            if(rs.data.courseStationList && rs.data.courseStationList.length>0){
              rs.data.courseStationList.forEach(v=>{
                arr.push(v.stationId)
              })
            }else{
              arr = []
            }
            that.editCourseInfoForm = {
              courseName: rs.data.courseName,
              subject: rs.data.subjectId,
              type: rs.data.courseType,
              coursePic: rs.data.courseLogo,
              classHour: rs.data.courseHour,
              courseIntroduction: rs.data.courseContext,
              courseDetails: rs.data.detail,
              post: arr
            }
          }else{
            this.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      getCourseCatalog(id){//获取课程目录
        let that = this;
        api.getCourseCatalog(id).then((rs)=>{
          if(rs.code==0){
            if(rs.data.length>0){
              that.treeData = rs.data
            }
            that.loading = false;
          }else{
            this.$messageError(rs.msg)
          }
        }).then(()=>{
        	let catalogId = this.$store.state.catalogId;
        	if(catalogId){
        		let index = 0;
	        	let obj = {};
	        	that.setCurrent(catalogId);
	        	that.treeData.forEach(v=>{
	        		if(catalogId == v.id){
	        			obj = v;
	        			return;
	        		}
	        		if(v.children.length){
	        			v.children.forEach(j=>{
	        				if(catalogId == j.id){
			        			obj = j;
			        			return
			        		}
	        				if(j.children.length){
			        			j.children.forEach(k=>{
			        				if(catalogId == k.id){
					        			obj = k;
					        		}
			        			})
			        		}
	        			})
	        		}
	        	});
        		that.handleNodeClick(obj);
        	}else{
            if(that.treeData.length>0){
              that.setCurrent(that.treeData[0].id)
              that.handleNodeClick(that.treeData[0])
            }
        	}
        }).catch((error)=>{
          console.log(error)
        })
      },
      setCurrent(id){//选中树节点
        this.$nextTick(function(){
          this.$refs.tree.setCurrentKey(id);
        })
      },
      handleNodeClick(data) {//点击课程目录
      	console.log(data);
        let that = this;
        this.loading = true
        this.selectTreeData = data
        this.isTreeNodeClick = true;
        this.catalogInfo.name = data.catalogName
        this.catalogInfo.id = data.id
        this.$store.state.catalogId = data.id
        api.handleNodeClick(that.courseId,data.id).then((rs)=>{
          that.seleceTask = []
          that.seleceDown = []
          if(rs.code == 0){
            if(rs.data!=null && rs.data.length>0){
              that.relatedMaterialData = rs.data
              const istask = this.relatedMaterialData.find(item=> item.resourceType==3)
              if(this.productFlag==7&& !istask){
                this.taskIsdisabled=true
              }else{
                this.taskIsdisabled=false
              }
              that.relatedMaterialData.forEach((v,i)=>{
                if(v.downloadFlag==1){ that.seleceDown.push(v.courseResourceId); }
                if(v.taskType==1){ that.seleceTask.push(v.courseResourceId); }
              })
              //任务
              that.isSelectAllTask = that.seleceTask.length === that.relatedMaterialData.length;
              that.isIndeterminateTask = that.seleceTask.length > 0 && that.seleceTask.length < that.relatedMaterialData.length;
              //下载
              let num = 0
              that.relatedMaterialData.forEach(v=>{
                if(v.resourceType==1){ num++ }
              })
              if(num == 0){
                that.isSelectAllDown = false;
                that.isIndeterminateDown = false;
              }else{
                that.isSelectAllDown = that.seleceDown.length === num;
                that.isIndeterminateDown = that.seleceDown.length > 0 && that.seleceDown.length < num;
              }
            }else{
              that.relatedMaterialData = []
              that.isSelectAllTask = false
              that.isSelectAllDown = false
              that.isIndeterminateTask = false
              that.isIndeterminateDown = false
            }
            that.loading = false
          }else{
            that.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      imgBg(resourceType,type){ //根据资源类型展示不同背景色
        if(resourceType==1 && type==1){
          return 'pic'
        }else if(resourceType==1 && type==2){
          return 'file'
        }else if(resourceType==1 && type==3){
          return 'audio'
        }else if(resourceType==1 && type==4){
          return 'video'
        }else if(resourceType==1 && type==5){
          return 'zip'
        }else if(resourceType==3){
          return 'question'
        }else{
          return 'test'
        }
      },
      previewDocument(data){//预览资源
        let that = this
        api.previewSource(data.id).then((rs)=>{
          if(rs.code==0){
            that.resourceInfo={
              name: rs.data.name,
              classification: rs.data.classify,
              uploader: rs.data.createUseStr,
              uploadTime: that.formatDate(rs.data.createTime)
            }
            let url = data.newAttaUrl
            that.resourceUrl = url
            if(data.type==1){//图片
              that.resourceVisible = 1
              that.dialogResourceVisible = true
            }else if(data.type==2){//文档
              that.resourceVisible = 2
              that.dialogResourceVisible = true
            }else if(data.type==3){//音频
              that.resourceVisible = 3
              that.dialogResourceVisible = true
            }else if(data.type==4){//视频
              that.resourceVisible = 4
              that.dialogResourceVisible = true
              // that.posterSrc = '../../../../../../static/img/course_kong.png'
            }else if(data.type==5){
              axios.post(`${process.env.UPLOAD_NAME}`+'/file/doesObjectExistZip',qs.stringify({filePath: data.newAttaUrl}),{
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  Authorization: 'bearer '+localStorage.getItem('Authorization')
                },
              }).then(res => {
                if (res.data.code == 0) {
                  window.open(data.newAttaUrl)
                } else {
                  that.$messageWarning("无法预览")
                }
              }).catch(error => {
                console.log(error);
              })
            }else{
              that.resourceVisible = 0
              that.dialogResourceVisible = false
            }
          }else{
            that.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      // wjl  实操题编辑，跳到资源库去
      handleGoResource(item){
        if(item.resourceType == 3){
        	// this.iframeShow = true;
	        	api.QueryTestData({
	          id: parseInt(item.id),
	          parentId: 0,
	        }).then(res =>{
	          if(res.code == 0 ){
	            let token = localStorage.getItem('Authorization')
              let url = process.env.RESOURSE_URL + '/#/?type=gxzx&token='+token+"&id="+item.id+"&labelId="+res.data.list[0].labels[0].id+"&companyId="+item.companyId+"&subjectId="+res.data.list[0].subjectId + '&professional=' + this.courseProfessional;
	            window.open(url)
	          }else{
              this.$messageError(res.msg)
            }
	        })
        }else if(item.resourceType == 5){
        	this.$router.push({
	          path:'/addTest',
	          query: {
	          	paperId: item.id,
	            courseId: this.$route.query.id,
	            subjectId: this.$route.query.subjectId,
	            courseName: this.$route.query.courseName,
	            catalogId: this.$store.state.catalogId,
	            subjectName: this.$route.query.subjectName
	          }
	        })
        }
      },
      formatDate(value) {//格式化时间
        var date = new Date(value);
        let Y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let H = date.getHours();
        let i = date.getMinutes();
        let s = date.getSeconds();
        if (m < 10) { m = '0' + m; }
        if (d < 10) { d = '0' + d; }
        if (H < 10) { H = '0' + H; }
        if (i < 10) { i = '0' + i; }
        if (s < 10) { s = '0' + s; }
        var t = Y + '-' + m + '-' + d + ' ' + H + ':' + i + ':' + s;
        return t;
      },
      sourceSort(evt){//素材移动排序
        let catalogId = this.catalogInfo.id
        let sortArr = []
        evt.from.childNodes.forEach(item=>{
          sortArr.push({
            "resourceId":item.dataset.key
          })
        })
        let obj = {
          "catalogId": catalogId,
          "courseId": this.courseId,
          "list": sortArr
        }
        this.sortFn(obj)
      },
      deleteSource1(item){//删除素材
        let that = this
        let tips = ''
        if(item.resourceType==1){
          tips = '正在删除素材《'+item.name+'》'
        }else if(item.resourceType==3){
          let str = item.name?item.name:'实操题'+item.id
          tips = '正在删除实操题《'+str+'》'
        }else if(item.resourceType==5){
          tips = '正在删除测验《'+item.name+'》'
        }else{
          tips = '确认删除该条数据吗？'
        }
        let isDelete = false
        if(item.resourceType==5){
          api.getExamRecord(this.courseId,item.id).then(rs=>{
            if(rs.code==0){
              isDelete = true
            }else{
              isDelete = false
            }
          }).then(()=>{
            if(isDelete){
              tips = '确定删除该测验吗？'
            }else{
              tips = '该测验已有学生作答，删除后该测验及学生作答记录也会清除，确定删除吗？'
            }
            that.deleteFn(item,tips)
          })
        }else{
          that.deleteFn(item,tips)
        }
      },
      deleteFn(item,tips){
        let that = this
        this.$tipsDialog(
          "提示",
          tips,
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        ).then(() => {
          let obj = {
            "catalogId": this.catalogInfo.id,
            "courseId": this.courseId,
            "list": [item.courseResourceId],
          }
          api.batchDeleteSource(obj).then(rs=>{
            if(rs.code==0){
              that.$messageSuccess('删除成功')
              for(let i=0;i<that.relatedMaterialData.length;i++){
                if(that.relatedMaterialData[i].courseResourceId==item.courseResourceId){
                  that.relatedMaterialData.splice(i,1)
                }
              }
            }else{
              that.$messageError(rs.msg)
            }
          }).catch(err=>{
            console.log(err)
          })
        }).catch(() => {

        });
      },
      addCatalog(){//添加一级目录
        let that = this
        let obj = {
          "catalogName": "新增章节",
          "catalogParentId": 0,
          "courseId": this.courseId
        }
        api.addCatalog(obj).then((rs)=>{
          if(rs.code == 0){
            let nodeObj = {
              catalogContext: rs.data.catalogContext,
              id: rs.data.id,
              catalogName: rs.data.catalogName,
              children: rs.data.children,
              catalogParentId: rs.data.catalogParentId,
              catalogSort:rs.data.catalogSort,
              courseId: rs.data.courseId,
              parentFlag: rs.data.parentFlag,
              targetId: rs.data.targetId,
              targetSort: rs.data.targetSort
            }
            that.treeData.push(nodeObj)
            that.editCatalog('node', nodeObj)
          }else{
            that.$messageError(rs.msg)
          }
          // that.getCourseCatalog(that.courseId)
        }).catch((error)=>{
          console.log(error)
        })
      },
      appendCatalog(data,node) {//追加子级目录
        if(node.level>=3){
          this.$messageWarning('最多只能添加三级节点')
        }else{
          let that = this
          let obj = {
            "catalogName": "新增节点",
            "catalogParentId": data.id,
            "courseId": data.courseId
          }
          that.defaultExpansion = []
          api.addCatalog(obj).then((rs)=>{
            const newChild = {
              catalogContext: rs.data.catalogContext,
              catalogName: rs.data.catalogName,
              catalogParentId: rs.data.catalogParentId,
              catalogSort: rs.data.catalogSort,
              children: rs.data.children,
              courseId: rs.data.courseId,
              id: rs.data.id,
              parentFlag: rs.data.parentFlag,
              targetId: rs.data.targetId,
              targetSort: rs.data.targetSort
            };
            if (!data.children) {
              this.$set(data, 'children', []);
            }
            data.children.push(newChild);
            that.defaultExpansion.push(newChild.id)
            that.editCatalog('node', newChild)
            // that.getCourseCatalog(that.courseId)
          }).catch((error)=>{
            console.log(error)
          })
        }
      },
      editCatalog(node, data){//编辑目录
        this.$set(data, "status", 1);
        this.$nextTick(() => {
          // let input=this.$refs['catalog'+data.id].$el.querySelector('input')
         let timer = setTimeout(()=>{
            this.$refs['catalog'+data.id].$refs.input.focus();
            this.$refs['catalog'+data.id].$refs.input.select();
            this.isdraggable = false
            clearTimeout(timer)
          },10)
        })
      },
      enterInput(event) {
        if (event) {
          event.target.blur()
        }
      },
      editCatalogSave(data, node){//编辑目录保存
        let that = this
        if(data.catalogName==''){
          this.$set(data, "status", 1);
          this.$nextTick(() => {
            this.$refs['catalog'+data.id].$refs.input.focus();
          })
          this.$messageWarning('目录名称不能为空')
          this.catalogFlag = true
          return
        }
        this.catalogFlag = false
        let obj = {
          id:data.id,
          catalogName:data.catalogName
        }
        api.editCatalogSave(obj).then((rs)=>{
          if(rs.code == 0){
            this.$messageSuccess('保存成功')
            that.catalogInfo.name = data.catalogName
            that.$set(data, "status", 0);
            this.isdraggable = true
          }else{
            this.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      removeCatalogFn(node, data){//删除目录
        if(this.catalogFlag) return
        let tips = '正在删除目录《'+data.catalogName+'》'
        this.$tipsDialog(
          "删除目录",
          tips,
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        ).then(() => {
          if(node.childNodes.length>0){
            this.$messageWarning('还有子节点，不能删除')
          }else{
            api.deleteCatalog(data.id).then((rs)=>{
              if(rs.code == 0){
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.id === data.id);
                children.splice(index, 1);
                this.isTreeNodeClick = false;
                this.relatedMaterialData = []
                this.$messageSuccess('删除成功')
              }else{
                this.$messageError(rs.msg)
              }
            }).catch((error)=>{
              console.log(error)
            })
          }
        }).catch(() => {

        });
      },
      //移动目录
      handleDragStart(node, ev) {
        // console.log('drag start', node);
      },
      handleDragEnter(draggingNode, dropNode, ev) {
        // console.log('tree drag enter: ', dropNode.label);
      },
      handleDragLeave(draggingNode, dropNode, ev) {
        // console.log('tree drag leave: ', dropNode.label);
      },
      handleDragOver(draggingNode, dropNode, ev) {
        // console.log('tree drag over: ', dropNode.label);
      },
      handleDragEnd(draggingNode, dropNode, dropType, ev) {
        // 拖拽结束时（可能未成功）触发的事件
        // console.log('tree drag end: ', dropNode && dropNode.label, dropType);
        let num = 1
        if(draggingNode.childNodes.length>0){
          num = 2
          draggingNode.childNodes.forEach((item,i)=>{
            if(item.childNodes.length>0){
              num=3
            }
          })
        }else{
          num = 1
        }
        if(dropType == 'inner'){
          this.treeDataLevel=dropNode.level+num
        }else{
          this.treeDataLevel=num
        }
      },
      handleDrop(draggingNode, dropNode, dropType, ev) {
        if(this.treeDataLevel>3){
          this.$messageWarning('目录层级最多为三级')
          this.getCourseCatalog(this.courseId)
          return
        }
        if(dropType == 'before'){
          dropType = 0
        }else if(dropType == 'inner'){
          dropType = 1
        }else{
          dropType = 2
        }
        // 拖拽成功完成时触发的事件
        let obj = {
          "catalogId": draggingNode.data.id,
          "courseId": this.courseId,
          "level": dropType,
          "targetId": dropNode.data.id
        }
        api.handleDrop(obj).then((rs)=>{
          if(rs.code == 0){
            console.log('移动成功')
          }else{
            this.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      upMove(index,item){//上移
        this.relatedMaterialData.splice(index - 1, 0, item)
        this.relatedMaterialData.splice(index + 1, 1)
        let sortArr = []
        this.relatedMaterialData.forEach(v=>{
          sortArr.push({
            "resourceId":v.id
          })
        })
        let obj = {
          "catalogId": this.catalogInfo.id,
          "courseId": this.courseId,
          "list": sortArr
        }
        this.sortFn(obj)
      },
      downMove(index,item){//下移
        this.relatedMaterialData.splice(index + 2, 0, item)
        this.relatedMaterialData.splice(index, 1)
        let sortArr = []
        this.relatedMaterialData.forEach(v=>{
          sortArr.push({
            "resourceId":v.id
          })
        })
        let obj = {
          "catalogId": this.catalogInfo.id,
          "courseId": this.courseId,
          "list": sortArr
        }
        this.sortFn(obj)
      },
      sortFn(obj){//移动
        api.moveMaterial(obj).then((rs)=>{
          if(rs.code==0){
            this.$messageSuccess('排序成功')
          }else{
            this.$messageError(rs.msg)
          }
        }).catch((error)=>{
          console.log(error)
        })
      },
      closeQuestion(){//关闭添加实操题滑块
        this.addQuestionShow = false
      },
      // 添加测验
      addTestpaperShow(item){
        this.$router.push({
          path:'/addTest',
          query: {
            courseId: this.$route.query.id,
            subjectId: this.$route.query.subjectId,
            courseName: this.$route.query.courseName,
            catalogId: item.id,
            subjectName: this.$route.query.subjectName
          }
        });
      },
      courseReload(){
        this.reload()
      },
      saveCourseInfo(){//编辑课程信息保存
        this.$refs.editInfo.clickConfirm()
      },
      addQuestionSave(){//添加实操题保存
        this.relatedMaterialData = this.$store.state.questionList;
        this.addQuestionShow = false
        this.$messageSuccess('添加成功')
        this.relatedMaterialData.forEach((v,i)=>{
          if(v.downloadFlag==1){ this.seleceDown.push(v.courseResourceId); }
          if(v.taskType==1){ this.seleceTask.push(v.courseResourceId); }
        })
      },
      handleCheckAllChange(flag,val) {//全选
        if(flag=='task'){
          if(val){
            this.seleceTask = []
            this.relatedMaterialData.forEach(item=>{
              this.seleceTask.push(item.courseResourceId);
            })
          }else{
            this.isSelectAllTask = false;
            this.seleceTask = [];
          }
          this.isIndeterminateTask = false;
          let arr = []
          this.relatedMaterialData.forEach(item=>{
            arr.push(item.courseResourceId);
          })
          let obj = {
            "catalogId": this.catalogInfo.id,
            "courseId": this.courseId,
            "list": arr,
            "taskType": val?1:0
          }
          this.updateSourceStatus(obj)
        }else if(flag=='down'){
          console.log(val)
          if(val){
            this.seleceDown = []
            this.relatedMaterialData.forEach(item=>{
              if(item.resourceType==1){
                this.seleceDown.push(item.courseResourceId);
              }
            })
          }else{
            this.isSelectAllDown = false;
            this.seleceDown = [];
          }
          this.isIndeterminateDown = false;
          let arr = []
          this.relatedMaterialData.forEach(item=>{
            if(item.resourceType==1){
              arr.push(item.courseResourceId);
            }
          })
          // if(this.seleceDown.length==0){
          //   this.$messageWarning('没有可选项')
          //   return
          // }
          if(arr.length==0){
            this.$messageWarning('没有可选项')
            return
          }
          let obj = {
            "catalogId": this.catalogInfo.id,
            "courseId": this.courseId,
            "dowloandFlag": val?1:0,
            "list": arr,
          }
          this.updateSourceStatus(obj)
        }else{
          if(val){
            this.seleceSource = []
            this.relatedMaterialData.forEach(item=>{
              this.seleceSource.push(item.courseResourceId);
            })
          }else{
            this.isSelectAll = false;
            this.seleceSource = [];
          }
          this.isIndeterminateSource = false;
        }
      },
      handleCheckedTopicChange(flag,value,item) {//单选
        let checkedCount = value.length;
        if(flag=='task'){
          this.isSelectAllTask = checkedCount === this.relatedMaterialData.length;
          this.isIndeterminateTask = checkedCount > 0 && checkedCount < this.relatedMaterialData.length;
          let taskType = 0
          if(value.includes(item.courseResourceId)){
            taskType = 1
          }else{
            taskType = 0
          }
          let obj = {
            "catalogId": this.catalogInfo.id,
            "courseId": this.courseId,
            "list": [item.courseResourceId],
            "taskType": taskType
          }
          this.updateSourceStatus(obj)
        }else if(flag=='down'){
          let num = 0
          this.relatedMaterialData.forEach(v=>{
            if(v.resourceType==1){ num++ }
          })
          this.isSelectAllDown = checkedCount === num;
          this.isIndeterminateDown = checkedCount > 0 && checkedCount < num;
          let downloadFlag = 0
          if(value.includes(item.courseResourceId)){
            downloadFlag = 1
          }else{
            downloadFlag = 0
          }
          let obj = {
            "catalogId": this.catalogInfo.id,
            "courseId": this.courseId,
            "dowloandFlag": downloadFlag,
            "list": [item.courseResourceId],
          }
          this.updateSourceStatus(obj)
        }else{
          this.isSelectAll = checkedCount === this.relatedMaterialData.length;
          this.isIndeterminateSource = checkedCount > 0 && checkedCount < this.relatedMaterialData.length;
        }
      },
      updateSourceStatus(obj) {
        api.batchChangeCheck(obj).then(rs=>{
          if(rs.code==0){
            this.$messageSuccess('设置成功')
            this.handleNodeClick(this.selectTreeData)
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      emptyData(){
        this.isIndeterminateSource = false;
        this.isSelectAll = false;
        this.seleceSource = [];
      },
      batchDelete(){//批量删除
        let that = this
        if(this.seleceSource==0){
          this.$messageWarning('请选择要删除项')
          return
        }
        this.$tipsDialog(
          "提示",
          "确认删除选中项？",
          "",
          "el-icon-warning",
          "rgb(255, 178, 60)"
        ).then(() => {
          let obj = {
            "catalogId": this.catalogInfo.id,
            "courseId": this.courseId,
            "list": this.seleceSource,
          }
          api.batchDeleteSource(obj).then(rs=>{
            if(rs.code==0){
              that.$messageSuccess('删除成功')
              that.handleNodeClick(that.selectTreeData)
            }else{
              that.$messageError(rs.msg)
            }
          })
        }).catch(() => {

        });
      },
      previewCourse(){//课程预览
        let that = this
        sessionStorage.setItem('isPreview', true)
        const { href } = this.$router.resolve({
          path: '/switch/courseware/preview',
          query: {
            id: that.courseId,
            courseName: this.courseName
          }
        });
        window.open(href, '_blank');
      },
      viewResourceConfirm(){//查看素材
        this.dialogResourceVisible = false
        this.resourceVisible=0
        this.resourceUrl=""
      },
      viewResourceCancel(){
        this.dialogResourceVisible = false
        this.resourceVisible=0
        this.resourceUrl=""
      },
      closeAddMaterial(){
        this.isAddMaterial = false;
        this.handleNodeClick(this.selectTreeData)
      },
      uploadMaterialDrawer(){//上传素材
        this.isUploadMaterial=true;
        if(this.$refs.uploadMaterial){
          console.log(this.courseForm)
          this.$refs.uploadMaterial.init(this.courseForm);
        }
      },
      createQuestionBtn(){//创建实操题
        api.FindTypeBySubject({
          subjectId: this.$route.query.subjectId,
        }).then(res => {
          if (res.code === "0") {
            if(res.data.length>0){
              let arr = []
              res.data.forEach(v=>{
                if(v.internaltypeid==9){
                  arr.push(v)
                }
              })
              if(arr.length>0){
                this.createQuestionShow = true
              }else{
                this.$messageWarning('该课程所属科目下暂无实操题题型，请先去“题型管理”添加相关题型！')
              }
            }else{
              this.$messageWarning('该课程所属科目下暂无题型，请先去“题型管理”添加题型！')
            }
          } else {
            this.$messageError(res.msg)
          }
        })
      },
      saveQuestion(obj,flag){//保存实操题
        if(!this.isCreate) return
        let that = this
        this.isCreate = false
        api.createQuestiontData(obj).then(rs=>{
          if(rs.code==0){
            let questionId = rs.data
            let Material = {
              catalogId: that.catalogInfo.id,
              courseId: that.courseId,
              list: [
                {
                  catalogId: that.catalogInfo.id,
                  courseId: that.courseId,
                  resourceId: rs.data,
                  type: 3,
                }
              ]
            }
            api.submitMaterialBtn(Material).then(res=>{
              if(res.code==0){
                that.$messageSuccess('添加成功')
                if(flag=='back'){
                  that.createQuestionShow = false
                  that.handleNodeClick(this.selectTreeData)
                }else{
                  that.createQuestionShow = false
                  that.handleNodeClick(this.selectTreeData)
                  // that.iframeShow = true;
                  api.QueryTestData({
                    id: parseInt(questionId),
                    parentId: 0,
                  }).then(result =>{
                    if(result.code == 0 ){
                      let token = localStorage.getItem('Authorization')
                      window.open(process.env.RESOURSE_URL + '/#/?type=gxzx&token='+token+"&id="+questionId+"&labelId="+result.data.list[0].labels[0].id+"&companyId="+result.data.list[0].companyId+"&subjectId="+result.data.list[0].subjectId + '&professional=' + this.courseProfessional);
                    }else{
                      that.$messageError(result.msg)
                    }
                  })
                }
              }else{
                that.$messageError(res.msg)
              }
            })
          }else{
            that.$messageError(rs.msg)
          }
          this.isCreate = true
        })
      },
      closeCreateQuestion(){//创建实操题关闭
        this.createQuestionShow = false
      },
      uploadMaterial(id){// 上传素材保存
        let that = this
        let obj = {
          catalogId: that.catalogInfo.id,
          courseId: that.courseId,
          list: [
            {
              catalogId: that.catalogInfo.id,
              courseId: that.courseId,
              resourceId: id,
              type: 1,
            }
          ]
        }
        api.submitMaterialBtn(obj).then(rs=>{
          if(rs.code==0){
            that.handleNodeClick(this.selectTreeData)
          }else{
            that.$messageError(rs.msg)
          }
        })
      },
      uploadMaterialClick(){
        this.isUploadMaterial=false;
      },
      setMenu(flag){//设置目录隐藏
        this.isSetMenu = flag
      }
    },
    watch: {
      'relatedMaterialData': function(){
        this.emptyData()
      }
    }
  }
</script>

<style scoped lang="scss">
  .editorial_course_wrap{
    height: calc(100% - 32px);
    background: #fff;
    padding: 0 16px;
    margin: 16px 16px 0;
    border-radius: 4px;
    .editorial_course_title{
      height: 60px;
      border-bottom: 1px solid #DDE0E2;
      display: flex;
      align-items: center;
      position: relative;
      h2{
        color: #333;
        font-size: 16px;
        margin-left: 24px;
        position: relative;
        font-weight: 600;
        &::after{
          content: '';
          position: absolute;
          left: -10px;
          top: 3px;
          width: 4px;
          height: 12px;
          background: #5397F7;
        }
      }
      .goback{
        cursor: pointer;
        font-size: 14px;
        display: flex;
        align-items: center;
        span{
          font-size: 14px;
          font-weight: 400;
        }
        img{
          height: 18px;
          margin: 0 3px;
        }
      }
      .edit_and_preview{
        position: absolute;
        right: 0;
        top: 15px;
        button{
          padding: 0 10px;
          height:32px;
          border:1px solid rgba(83,151,247,1);
          border-radius:4px;
          color:#fff;
          background: #5397F7;
        }
        button:hover{
          opacity: 0.8;
        }
      }
    }
    .course_info{
      margin-top: 15px;
      display: flex;
      .course_tree{
        width:250px;
        .course_chapters{
          width:100%;
          height:40px;
          background:url('../../../../static/images/course/tree-title-bag.png') no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          h3{
            width: 190px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size:14px;
            font-weight:400;
            line-height:40px;
            color:rgba(255,255,255,1);
            margin-left: 12px;
          }
          img{
            width: 16px;
          }
          .icon{
            margin-left: 8px;
          }
          .add_course_btn{
            cursor: pointer;
          }
        }
        /deep/ .course_CTreeCtrl{
          background: #fff;
          overflow-y:auto;
          .el-tree-node__content{
            height: 32px;
            position: relative;
            .el-tree-node__expand-icon{
              color: #5397F7;
            }
            .el-tree-node__expand-icon.is-leaf{
              color: transparent !important;
              cursor: default;
            }
            .custom-tree-node{
              font-size:12px;
              font-weight:400;
              color: #333333;
              width: calc(100% - 35px);
              span:first-child{
                display:inline-block;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .custom-tree-node:hover{
              .course_catalog_operation{
                display: block;
              }
            }
            .course_catalog_operation{
              display: none;
              // position: absolute;
              // top: 2px;
              // right: 10px;
              i{
                margin-left: 3px;
                color: #5397F7;
              }
            }
          }
          .el-tree-node>.el-tree-node__children{
            overflow:inherit;
          }
          .el-tree-node.is-current > .el-tree-node__content {
            background-color: #EDF4FF;
            border-left: 2px solid #5397F7;
          }
          .el-tree-node__content:hover{
            background: #EDF4FF;
          }
        }
      }
      .editorial_course_content{
        margin-left: 15px;
        padding: 0 16px;
        box-sizing:border-box;
        width: calc(100% - 250px);
        .cc_title{
          width: 100%;
          height: 70px;
          position: relative;
          h2{
            padding-left: 4px;
            display: flex;
            align-items: center;
            width: calc(100% - 20px);
            img{
              width: 24px;
              height: 24px;
            }
            p{
              display: inline-block;
              color: #333;
              font-size: 16px;
              margin-left: 10px;
              font-weight: 600;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .operation_btn{
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            /deep/ .operation_btn_left{
              .el-checkbox{
                margin-right: 20px;
                .el-checkbox__label{
                  padding-left: 5px;
                  font-size:12px;
                  color:rgba(93,100,110,1);
                }
              }
            }
            .operation_btn_right{
              min-width: 520px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              button{
                height:32px;
                border:1px solid rgba(83,151,247,1);
                opacity:1;
                border-radius:4px;
                color:#fff;
                padding: 0 10px;
                background: #5397F7;
                margin-left: 8px;
                &:hover{
                  opacity: 0.8;
                }
              }
              .block{
                width: 32px;
                height: 32px;
                position: relative;
                &::after{
                  content: '';
                  position: absolute;
                  left: 6px;
                  top: 8px;
                  width: 18px;
                  height: 15px;
                  background: url('../../../../static/images/course/icon-5.png');
                  background-size: 100% 100%;
                }
              }
              .list{
                width: 32px;
                height: 32px;
                position: relative;
                &::after{
                  content: '';
                  position: absolute;
                  left: 6px;
                  top: 8px;
                  width: 18px;
                  height: 15px;
                  background: url('../../../../static/images/course/icon-6.png');
                  background-size: 100% 100%;
                }
              }
            }
          }
          .el-input{
            height: 25px;
            .el-input__inner{
              height: 25px;
            }
          }
        }
        .cc_content{
          width:100%;
          // height:431px;
          margin: 0;
          overflow-y:auto;
          .el-checkbox-group{
            font-size: inherit
          }
          .source_table_title{
            display: flex;
            height: 40px;
            align-items: center;
            justify-content: space-between;
            p{
              font-size:12px;
              color:rgba(93,100,110,1);
              text-align: center;
              &:nth-child(1){ width: 55px; }
              &:nth-child(2){ width: 65px; }
              &:nth-child(3){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
              &:nth-child(4){ width: 7%; }
              &:nth-child(5){ width: 10%; }
              &:nth-child(6){ width: 10%; }
              &:nth-child(7){ width: 20%; }
            }
          }
          .block{
            padding: 16px 5px 0;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            li{
              width: 180px;
              height: 165px;
              margin: 0 13px 16px;
              position: relative;
              border: 1px solid #ebebeb;
              &:hover{
                box-shadow:0px 0px 10px rgba(0,0,0,0.11);
              }
              .img_box{
                width:160px;
                height: 68px;
                border: 1px solid rgba(226,226,226,1);
                border-radius: 8px;
                position: relative;
                text-align: center;
                margin: 10px auto 0;
                /deep/ .select_box{
                  position: absolute;
                  left: 8px;
                  top: 2px;
                  .el-checkbox__label{
                    display: none;
                  }
                  .el-checkbox__inner{
                    background: none;
                    border: 1px solid #fff;
                  }
                }
                .delete_source{
                  width: 12px;
                  height: 12px;
                  position: absolute;
                  right: 10px;
                  top: 8px;
                  cursor: pointer;
                }
                .source_icon{
                  width: 32px;
                  height: 32px;
                  position: absolute;
                  right: 0;
                  top: 0;
                  bottom: 0;
                  left: 0;
                  margin: auto;
                }
                .imgMark{
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.2);
                  position: absolute;
                  left: 0;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  z-index: 9;
                }
                .typeImg{
                  width: 24px;
                  height:24px;
                  position: absolute;
                  right: 10px;
                  bottom: 10px;
                  z-index: 10;
                }
              }
              .pic{background: url('../../../../static/images/course/blockIcon/pic-bg.png');background-size: 100% 100%;}
              .file{background: url('../../../../static/images/course/blockIcon/file-bg.png');background-size: 100% 100%;}
              .audio{background: url('../../../../static/images/course/blockIcon/audio-bg.png');background-size: 100% 100%;}
              .video{background: url('../../../../static/images/course/blockIcon/video-bg.png');background-size: 100% 100%;}
              .zip{background: url('../../../../static/images/course/blockIcon/zip-bg.png');background-size: 100% 100%;}
              .question{background: url('../../../../static/images/course/blockIcon/question-bg.png');background-size: 100% 100%;}
              .test{background: url('../../../../static/images/course/blockIcon/test-bg.png');background-size: 100% 100%;}
              .title_box{
                width: 160px;
                height: 32px;
                line-height: 16px;
                margin: 6px auto 10px;
                position: relative;
                p{
                  font-size:14px;
                  font-weight:normal;
                  line-height:16px;
                  color:rgba(13,20,30,1);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  word-break: break-all;
                }
                .el-icon-edit-outline{
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  font-size: 14px;
                  cursor: pointer;
                  &:hover{
                    color: #409EFF;
                    font-size: 15px;
                  }
                }
              }
              /deep/ .isDownload{
                width:160px;
                margin: 8px auto 0;
                display: flex;
                justify-content: space-between;
                .el-checkbox__inner{
                  border-radius: 4px;
                }
                .el-checkbox__label{
                  font-size: 12px;
                  padding-left: 5px;
                }
                .el-checkbox{
                  margin: 0;
                }
              }
            }
          }
          .list{
            li{
              width:100%;
              min-height:40px;
              background:rgba(246,248,251,1);
              border-radius:4px;
              margin-bottom: 8px;
              display: flex;
              align-items: center;
              /deep/ .select_box{
                .el-checkbox{
                  display: inline-block;
                }
                .el-checkbox__label{
                  display: none;
                }
              }
              .index_box{
                font-size:12px;
                color:rgba(13,20,30,1);
              }
              .title_box{
                p{
                  font-weight:normal;
                  color:rgba(13,20,30,1);
                  font-size:12px;
                }
              }
              .type_box{
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                  width: 16px;
                  height: 16px;
                }
                span{
                  width: 30px;
                  font-size:12px;
                  color:rgba(13,20,30,1);
                  margin-left: 4px;
                }
              }
              .task_box,.down_box{
                /deep/ .el-checkbox__label{
                  display: none;
                }
              }
              .operation_box{
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                  margin-right: 16px;
                  cursor: pointer;
                  &:last-child{
                    margin-right: 0;
                  }
                }
                .preview_source{
                  width: 14px;
                  height: 14px;
                  background: url('../../../../static/images/course/editSourceIcon/preview.png');
                  background-size: 100% 100%;
                  &:hover{
                    background: url('../../../../static/images/course/editSourceIcon/preview-hv.png');
                    background-size: 100% 100%;
                  }
                }
                .edit_source{
                  width: 14px;
                  height: 14px;
                  background: url('../../../../static/images/course/editSourceIcon/edit.png');
                  background-size: 100% 100%;
                  &:hover{
                    background: url('../../../../static/images/course/editSourceIcon/edit-hv.png');
                    background-size: 100% 100%;
                  }
                }
                .delete_source{
                  width: 14px;
                  height: 14px;
                  background: url('../../../../static/images/course/editSourceIcon/delete.png');
                  background-size: 100% 100%;
                  &:hover{
                    background: url('../../../../static/images/course/editSourceIcon/delete-hv.png');
                    background-size: 100% 100%;
                  }
                }
                .down_source{
                  width: 14px;
                  height: 14px;
                  background: url('../../../../static/images/course/editSourceIcon/down.png');
                  background-size: 100% 100%;
                  &:hover{
                    background: url('../../../../static/images/course/editSourceIcon/down-hv.png');
                    background-size: 100% 100%;
                  }
                }
                .up_source{
                  width: 14px;
                  height: 14px;
                  background: url('../../../../static/images/course/editSourceIcon/up.png');
                  background-size: 100% 100%;
                  &:hover{
                    background: url('../../../../static/images/course/editSourceIcon/up-hv.png');
                    background-size: 100% 100%;
                  }
                }
              }
              div{
                text-align: center;
                word-break: break-all;
                &:nth-child(1){ width: 55px; }
                &:nth-child(2){ width: 65px; }
                &:nth-child(3){ flex: 1; text-align: left; padding: 0 16px; box-sizing: border-box; }
                &:nth-child(4){ width: 7%; }
                &:nth-child(5){ width: 10%; }
                &:nth-child(6){ width: 10%; }
                &:nth-child(7){ width: 20%; }
              }
            }
          }
          .is_material{
            text-align: center;
            img{
              width: 140px;
              height: 140px;
              margin-top: 120px;
            }
            p{
              font-size:12px;
              font-weight:400;
              line-height:16px;
              color:#999999;
              span{
                color: #5397F7;
                cursor: pointer;
                margin-left: 2px;
              }
            }
          }
        }
        .no_content{
          text-align: center;
          img{
            margin-top: 10%;
          }
          p{
            margin-top: 10px;
          }
        }
      }
    }
    .edit_info {
      height: calc(100% - 65px);
      overflow-y: auto;
    }
    /deep/ .material_dialog{
      .el-dialog__header{
        width:832px;
        height:48px;
        background:rgba(237,244,255,1);
        border-radius:8px 8px 0px 0px;
        padding: 20px 0 0 0;
        box-sizing: border-box;
        line-height: 48px;
        .el-dialog__title{
          display: block;
          font-size:14px;
          font-weight:400;
          color:rgba(83,151,247,1);
          border-left: 2px solid #5397F7;
          line-height: 10px;
          padding-left: 3px;
          margin-left: 16px;
        }
        .el-dialog__headerbtn{
          top:16px;
        }
      }
      .el-dialog__body{
        padding: 16px 16px 0;
        display: flex;
        justify-content: space-between;
        .material_dialog_left{
          width: 200px;
          height:358px;
          border:1px solid rgba(235,235,235,1);
          opacity:1;
          border-radius:4px;
          overflow: auto;
          .tree_wrap{
            .tree_title{
              width: 100%;
              height: 32px;
              background: #5397f7;
              border-radius: 4px 4px 0px 0px;
              position: relative;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 14px;
              font-weight: 400;
              line-height: 32px;
              color: white;
              padding: 0 12px;
              box-sizing: border-box;
            }
          }
          .el-tree-node__content{
            height: 32px;
            position: relative;
            .el-tree-node__expand-icon{
              color: #5397F7;
            }
            .el-tree-node__expand-icon.is-leaf{
              color: transparent !important;
              cursor: default;
            }
            .custom-tree-node{
              font-size:12px;
              font-weight:400;
              color: #333333;
              width: 80%;
              span:first-child{
                display:inline-block;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .course_catalog_operation{
              // position: absolute;
              // top: 2px;
              // right: 10px;
              i{
                margin-left: 3px;
              }
            }
          }
          .el-tree-node.is-current > .el-tree-node__content {
            background-color: #EDF4FF;
            border-left: 2px solid #5397F7;
          }
          .el-tree-node__content:hover{
            background: #EDF4FF;
          }
        }
        .material_dialog_right{
          width: 584px;
          .material_search{
            display: flex;
            .material_name input,.material_type input,.material_tel input{
              height:30px;
              border:1px solid rgba(226,226,226,1);
              border-radius:4px;
            }
            .material_name{
              width: 160px;
              margin-right:16px;
            }
            .material_type{
              width:100px;
              margin-right:16px;
            }
            .material_tel{
              width:200px;
              margin-right:24px;
            }
            .el-input .el-input__inner{
              font-size: 12px;
              padding: 0 10px 0 25px;
            }
            .el-select .el-input__inner{
              font-size: 12px;
              padding: 0 20px 0 10px;
            }
            .el-input__icon{
              width: 15px;
              line-height: 30px;
            }
            button{
              width:72px;
              height:30px;
              border:1px solid rgba(83,151,247,1);
              opacity:1;
              border-radius:4px;
              color:#5397F7;
              padding: 0;
            }
            button:hover{
              background: #5397F7;
              color: #fff;
            }
          }
          .el-table{
            width:584px;
            height:280px;
            border:1px solid rgba(235,235,235,1);
            border-radius:4px;
            margin-top: 8px;
            .el-table__body-wrapper{
              .el-table__body{
                .el-table__row{
                  line-height: 40px;
                  td{
                    img{
                      margin-top:6px;
                    }
                  }
                }
              }
              .empty_data{
                img{
                  width: 100px;
                }
                p{
                  color:#909399;
                }
              }
            }
          }
        }
      }
      .el-dialog__footer{
        width:808px;
        height:52px;
        border-top:1px solid rgba(230,234,238,1);
        margin: 20px auto 0;
        button{
          width:79px;
          height:32px;
          // border:1px solid rgba(83,151,247,1);
          background: #fff;
          border-radius:4px;
        }
        button:hover{
          background: #5397F7;
          color: #fff;
        }
        .el-button--primary{
          color: #5397F7;
        }
      }
      .el-button, .el-button.is-round{
        padding: 5px 18px;
        font-size: 10px;
        color: #5397F7;
      }
      .el-button.is-round:hover{
        background:#5397F7;
        color:#fff;
      }
    }
    .el-drawer__header{
      font-size: 20px;

    }
    //===============编辑课程信息=============
    /deep/ .edit_course_form{
      width: 80%;
      margin: 48px auto 0;
      .el-form-item{
        width: 100%;
        display: flex;
        .el-form-item__label{
          width: 100px;
          line-height: 32px;
        }
      }
      .el-form-item__content{
        width: calc(100% - 100px);
        line-height: 32px;
        .el-input{
          width: 80%;
          .el-input__inner{
            height: 32px;
            line-height: 32px;
          }
          .el-input__icon{
            line-height: 32px;
          }
        }
        .el-textarea{
          width: 80%;
          .el-input__count{
            line-height: 20px;
          }
        }
      }
      .classHour{
        .el-form-item__content{
          .el-input{
            width: 260px;
          }
        }
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover{
          border-color: #409EFF;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width:88px;
          height:88px;
          line-height: 88px;
          text-align: center;
        }
        .avatar {
          max-width:154px;
          min-width:88px;
          height:88px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(226,226,226,1);
          opacity:1;
          border-radius:4px;
          display:block;
        }
      }
      .course_details{
        width: 80%;
      }
    }
  }
  /deep/ .el-drawer{
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/course/editCourse.vue